import React, { Component } from 'react';

import { Link } from 'react-router-dom'

// コンポーネント読み込み
import Loading from './Loading'

class VisitedSpotList extends Component {

  render() {
    let spot_list_jsx = []
    if (this.props.spotList) {
       spot_list_jsx = this.props.spotList.map(spot => {
        return (
          <Link key={`${spot.key}`} to={`/mypage/spot/${spot.name}`}>
            <div className="VisitedSpotList-item" key={spot.key} onClick={() => {this.props.setSelectedSpot(spot)}}>
              <img src={spot.image} alt=''/>
              <div className="VisitedSpotList-item-detail">
                <div className="VisitedSpotList-item-name">{spot.name}</div>
                <div className="VisitedSpotList-item-description">
                  {spot.description.length > 50? spot.description.substr(0, 50) + '...': spot.description}
                </div>
              </div>
            </div>
          </Link>
        )
      })
    } else {
      return (
        <Loading />
      )
    }
    if (spot_list_jsx.length > 0) {
      return (
        <div className="VisitedSpotList">
          {spot_list_jsx}
        </div>
      )
    } else {
      return (
        <div className="VisitedSpotList">
          訪問済みのスポットがありません
        </div>
      )
    }

  }
}

export default VisitedSpotList;
